export default __webpack_public_path__ + "static/media/sweet-6.0582d504.jpg";